import classNames from 'classnames';
import { useCallback } from 'react';
import { Heading, useModal } from 'yoso';
import { myCitizenItemsUrl } from '~/components/Dosi/Dosi.hooks';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { useFriendAbilities } from '~/components/Evolve/Ability/FriendAbility.hooks';
import { FriendAbilitiesPopup } from '~/components/Evolve/Ability/Popup/FriendAbilitiesPopup';
import { T } from '~/components/I18n/Translation';
import { Boost2D, Info } from '~/components/Icon';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { useMember } from '~/components/Member/Member.hooks';
import { useNftCount } from '~/components/Membership/Membership.hooks';
import { StatusBarAccordion } from '~/components/Status/Bar/Accordion/StatusBarAccordion';
import statusBarStyles from '~/components/Status/Bar/StatusBar.module.scss';
import myItemsStyles from '~/components/Status/Bar/StatusBarMyItems.module.scss';
import profileStyles from '~/components/Status/Bar/StatusBarProfile.module.scss';
import { format, formatBoost } from '~/components/Util/number';
import styles from './EvolveStatusBar.module.scss';
export type EvolveStatusBarProps = {
  className?: string;
};

export const EvolveStatusBar = ({ className }: EvolveStatusBarProps) => {
  const {
    data: { totalBoost },
  } = useFriendAbilities();
  const {
    data: { additional },
    isInitialLoading,
  } = useNftCount({ category: 'ADDITIONAL' });
  const { open } = useModal();
  const onInfoClick = useCallback(() => {
    if (totalBoost !== 0) {
      open(<FriendAbilitiesPopup />);
    }
  }, [totalBoost, open]);
  const {
    data: { profileImageUrl, nickname },
  } = useMember();
  const { open: openViewer } = useEmbeddedViewer();
  const onFriendsClick = useCallback(() => {
    openViewer(myCitizenItemsUrl);
  }, [openViewer]);

  return (
    <div className={classNames(statusBarStyles.root, styles.root, className)}>
      <div className={classNames(statusBarStyles.header, styles.profile)}>
        <img
          src={profileImageUrl || ''}
          alt={nickname || 'Profile Image'}
          className={profileStyles.image}
          width={50}
          height={50}
        />
        <div className={classNames(profileStyles.body, styles.profileBody)}>
          <Heading level={4} className={profileStyles.title}>
            {nickname}
          </Heading>
          <div className={classNames(profileStyles.description, styles.profileDescription)}>
            <div className={styles.boostAbility} onClick={onInfoClick}>
              <T name="citizen_evolve_myboost" /> <Boost2D className={styles.boostIcon} />
              <strong>{formatBoost(totalBoost)}%</strong> <Info className={styles.infoIcon} />
            </div>
          </div>
        </div>
      </div>
      <div className={statusBarStyles.body}>
        <StatusBarAccordion>
          <Heading level={4} className={myItemsStyles.title}>
            <T name="citizen_land_menu_myhistory_asset_desc" />
          </Heading>
          <DescriptionList
            layout="responsive"
            className={classNames(myItemsStyles.list, styles.myItemsList)}>
            <dt onClick={onFriendsClick}>Friends</dt>
            <dd onClick={onFriendsClick}>
              <T
                name="citizen_unit"
                options={{
                  count: additional?.friendsCount,
                  0: format(additional?.friendsCount, { zeroAsEmpty: isInitialLoading }),
                }}
              />
            </dd>
          </DescriptionList>
        </StatusBarAccordion>
      </div>
    </div>
  );
};
